export interface LocationClass {
    AccountLocationId: number
    AccountLocation: string
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}

const common = {    
  AccountLocation:"",
  IsDisabled:false
};
export const LocationInitialsForAdd = { ...common };

export const LocationInitialsForUpdate = {
  ...common,
  AccountLocationId: 0
};

